import {provideTransloco, provideTranslocoTranspiler, TranslocoModule, TranslocoService} from "@jsverse/transloco";
import {TranslocoRefTranspiler} from "./transloco-ref-transpiler";
import {provideAppInitializer, inject, isDevMode, NgModule} from "@angular/core";
import {TranslocoHttpLoader} from "./transloco-loader";
import {LorenUtilsService} from "./shared/services/loren-utils-service/loren-utils.service";
import {Language} from "./shared/enums/language.enum";
import {firstValueFrom} from "rxjs";

const lastSelectedLanguage = LorenUtilsService.getLastSelectedLanguage();

const preloadLanguagesFn = () => {
    const translocoService = inject(TranslocoService);
    const langs = [Language.EN, Language.BG];
    return Promise.all(langs.map(lang => firstValueFrom(translocoService.load(lang))));
};

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: [Language.EN, Language.BG],
                defaultLang: lastSelectedLanguage ? lastSelectedLanguage : Language.BG,
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader,
        }),
        provideTranslocoTranspiler(TranslocoRefTranspiler),
        provideAppInitializer(preloadLanguagesFn),
    ],
})
export class TranslocoRootModule {
}
